import { render } from "./TriggerNodeConfig.vue?vue&type=template&id=3b24018f&scoped=true&ts=true"
import script from "./TriggerNodeConfig.vue?vue&type=script&lang=ts"
export * from "./TriggerNodeConfig.vue?vue&type=script&lang=ts"

import "./TriggerNodeConfig.vue?vue&type=style&index=0&id=3b24018f&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b24018f"]])

export default __exports__